<template>
  <div class="employee-library-list">
    <el-form :inline="true" size="small" class="toolbar">
      <el-form-item label="姓名"
        ><el-input
          v-model.trim="name"
          clearable
          placeholder="请输入姓名"
          style="width:240px"
          @keyup.enter.native="search"
      /></el-form-item>
      <el-form-item label="身份证号"
        ><el-input v-model.trim="idCard" clearable placeholder="请输入身份证号" style="width:240px" @keyup.enter.native="search" /></el-form-item>
      <el-form-item
        ><el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        ><el-button icon="el-icon-refresh" @click="reset">重置</el-button
        ><el-button type="warning" icon="el-icon-plus" @click="edit()"
          >添加</el-button
        ></el-form-item
      >
    </el-form>
    <el-table
      :data="rows"
      border
      stripe
      v-loading="loading"
      height="calc(100vh - 245px)"
    >
      <el-table-column prop="name" label="姓名" min-width="180" />
      <el-table-column prop="id_card" label="身份证号" min-width="220" />
      <el-table-column label="创建时间" width="180"
        ><template slot-scope="s">{{
          date(s.row.created_at)
        }}</template></el-table-column
      >
      <el-table-column label="更新时间" width="180"
        ><template slot-scope="s">{{
          date(s.row.updated_at)
        }}</template></el-table-column
      >
      <el-table-column label="操作" width="100"
        ><template slot-scope="s"
          ><el-button type="text" @click="edit(s.row.id)"
            >编辑</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <el-pagination
      class="pagination"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 15, 20, 25]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="changeSize"
      @current-change="changePage"
    />
    <employee-library-dialog
      :visible.sync="dialogVisible"
      :employee-id="currentId"
      @success="fetchData"
    />
  </div>
</template>
<script>
import dayjs from "dayjs";
import { getEmployerEmployeeLibrary } from "@/api/employer-insurance";
import EmployeeLibraryDialog from "./components/EmployeeLibraryDialog.vue";
export default {
  name: "EmployeeLibraryList",
  components: { EmployeeLibraryDialog },
  data() {
    return {
      loading: false,
      name: "",
      idCard: "",
      rows: [],
      page: 1,
      pageSize: 15,
      total: 0,
      dialogVisible: false,
      currentId: ""
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = { page: this.page, rows: this.pageSize };
        if (this.name) params.name = this.name;
        if (this.idCard) params.id_card = this.idCard;
        const res = await getEmployerEmployeeLibrary(params);
        this.rows = (res && res.rows) || [];
        this.total = Number((res && res.total) || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    reset() {
      this.name = "";
      this.idCard = "";
      this.page = 1;
      this.fetchData();
    },
    edit(id) {
      this.currentId = id || "";
      this.dialogVisible = true;
    },
    changeSize(v) {
      this.pageSize = v;
      this.page = 1;
      this.fetchData();
    },
    changePage(v) {
      this.page = v;
      this.fetchData();
    },
    date(v) {
      return v ? dayjs(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    }
  }
};
</script>
<style lang="less" scoped>
.toolbar {
  margin-bottom: 12px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
